import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button';
import oh from 'output-helpers';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';

export default function AlertDialog(props) {
    const { onClose, open, content, title } = props;

    return (
        <Dialog open={open} onClose={onClose} scroll={'paper'}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers={true}>
                {typeof content === 'string' && (
                    <DialogContentText style={{ whiteSpace: 'pre-line' }}>
                        {content}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    filled
                    block
                    dark
                    label={oh.translate('back')}
                    onClick={onClose}
                />
            </DialogActions>
        </Dialog>
    );
}

AlertDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/base/AlertDialog.jsx